function updateLeasePrice() {
  if ($('#multistepForm').length) {
    // reset frontend
    $('#leasePrice').html("");

    // grab the net cost
    netCost = $('.price-field').text().substring(1).replace(',','')*100;

    var term = $('#leaseRentalTerm option:selected').val(); // grab the selected lease rental term

    // Calculate Lease Pricing from the Net Cost
    // var highRate = [32.77, 25.96, 21.90]; // rates for 1-5k
    // var lowRate = [32.44, 25.61, 21.54]; // rates over and equal to 5k
    // var leaseRate = netCost <= 500000 ? highRate[term-3] : lowRate[term-3];


    // Using metafields now for easy updating of rates via shopify content metaobjects in settings.
    var leaseRate = window.highRate[term-3];

    
    var monthlyPrice = (netCost/1000)*leaseRate; // add the lease rate to the net cost
    var payments = term*12;
    var leasePrice = monthlyPrice*payments;
    var leaseFilter = escapeHtml($('#product_form').find('.filtersUpsell option:selected').text());
    var leaseMaintenance = escapeHtml($('#product_form').find('.maintenanceUpsell option:selected').text());
    var leaseInstallation = escapeHtml($('#product_form').find('.installationUpsell option:selected').text());
    var leaseSku = $('#productSku').text();

    $('#leasePrice').html(`
      <p class="mb-1">Only</p>
      <h3 class="fw-bold mb-1">${Shopify.formatMoney(monthlyPrice, moneyFormat)}</h3>
      <p class="mb-0">Per Month</p>
    `);

    leaseFilter.length && $('#leaseFilter').html(`<p class="border-bottom w-100">${leaseFilter}</p>`);
    leaseMaintenance.length && $('#leaseMaintenance').html(`<p class="border-bottom w-100">${leaseMaintenance}</p>`);
    leaseInstallation.length && $('#leaseInstallation').html(`<p class="border-bottom w-100">${leaseInstallation}</p>`);
    $('#leaseSku').html(`<p class="border-bottom w-100">Sku: ${leaseSku}</p>`);

    // insert hidden form data
    $('#hiddenFields').html(`
      <input type="hidden" name="equipment_sku" value="${leaseSku}">

      <!-- lease pricing -->
      <input type="hidden" name="lease_rate" value="${leaseRate}">
      <input type="hidden" name="lease_net_cost" value="${Shopify.formatMoney(netCost, moneyFormat)}">
      <input type="hidden" name="lease_term" value="${term} Years">
      <input type="hidden" name="lease_amount" value="${Shopify.formatMoney(leasePrice, moneyFormat)}">
      <input type="hidden" name="lease_profile" value="1 + ${payments-1}">

      <!-- lease breakdown -->
      <input type="hidden" name="lease_filter" value="${leaseFilter}">
      <input type="hidden" name="lease_maintenance" value="${leaseMaintenance}">
      <input type="hidden" name="lease_installation" value="${leaseInstallation}">
    `);
  }
}